import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardHeader, CardBody, Col, Form, Row, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { H3, Breadcrumbs, Btn, H4 } from '../../AbstractElements';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import DatePicker from 'react-datepicker';
import { getClientUrlDataToken } from '../../Utils/restUtils';
import { Export, Search, Filter, PaymentCollectionRep, PaymentCollectionList } from '../../Constant';
import { getCollectionReportRole, getCollectionReport, getUsers, getUsersRole, getStb, getStbRole } from '../../CommonUrl';
import { useSelector } from 'react-redux';
import moment from 'moment';
import Transparentspinner from '../Common/Loader/Transparentspinner';
import { EarningsSvg } from '../../Data/Widgets/General/Data';
import Progress from '../Common/Progress';
import { useForm } from 'react-hook-form';
import UserDropdown from '../Common Field/UserDropdown';
import AreaDropdown from '../Common Field/AreaDropdown';


const CustomerPaymentReport = () => {
    const authState = useSelector((state) => state.auth);
    const location = useLocation();
    const searchParams = location.search;
    const params = new URLSearchParams(searchParams);
    const [filters, setFilters] = useState({
        searchKey: params.get('search') || '',
        start_date: params.get('start_date') ? moment(params.get('start_date'), "DD-MM-YYYY").toDate() : '',
        end_date: params.get('end_date') ? moment(params.get('end_date'), "DD-MM-YYYY").toDate() : '',
        userId: params.get("user") || ''
    });
    const param1 = params.get("day") || '';
    const sortedBy = params.get("sortBy") || '';
    const sortedOrder = params.get("sortOrder") || '';
    const [customerLists, setCustomerList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [dateRange, setDateRange] = useState([filters.start_date, filters.end_date]);
    const [startDate, endDate] = dateRange
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleStyle = { padding: '10px 20px', opacity: '0.8', fontSize: '14px' }
    const [apiUsers, setapiUsers] = useState([]);
    const [totalsum, settotalsum] = useState("0");
    const formatStartDate = filters.start_date ? moment(filters.start_date).format("DD-MM-YYYY") : '';
    const formatEndDate = filters.end_date ? moment(filters.end_date).format("DD-MM-YYYY") : '';
    const [sortConfig, setSortConfig] = useState({ column: sortedBy, order: sortedOrder });
    const { register, handleSubmit, setValue } = useForm({
        defaultValues: { search: filters.searchKey, user: filters.userId, },
    });

    const StaticWidgetsData = [
        {
            id: 1,
            title: 'Total Collected',
            counter: parseFloat(totalsum.toString().replace(/,/g, '')),
            svg: <EarningsSvg />,
            class: 'progress-gradient-secondary',
            progress: '75%'
        },
    ];

    const PaymentCollectionColumns = [
        {
            name: <H4>Sl</H4>,
            selector: row => row.Si,
            center: false,
            width: '80px'
        },
        {
            name: <H4>Customer Id</H4>,
            id: 'subscriber_id',
            selector: row =>
                (authState.userRole === 1 || authState.permissions.includes('show-customer-profile')) ?
                    <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/customers/customer/userProfile?id=${row.customer_id}`}>
                        {row.SubId}
                    </Link> : row.SubId,
            sortable: true,
            wrap: true,
            center: false,
            width: '110px',
        },
        {
            name: <H4>Name</H4>,
            id: 'name',
            selector: row => row.Name,
            sortable: true,
            center: false,
            wrap: true
        },
        {
            name: <H4>Bin Id</H4>,
            id: 'effected_bins',
            selector: row => row.Sub,
            sortable: true,
            wrap: true,
            width: '105px',
        },
        {
            name: <H4>Invoice Type</H4>,
            id: 'invoice_type',
            selector: row => row.Type,
            sortable: true,
            wrap: true,
            width: '140px',
        },
        {
            name: <H4>Receipt No</H4>,
            selector: row =>
                <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/billing/thermal-print?payment_id=${row.payment_id}`}>
                    {row.payment_id}
                </Link>,
            sortable: true,
            wrap: true
        },
        // {
        //     name: <H4>Invoice No.</H4>,
        //     id: 'invoice_no',
        //     selector: row =>
        //         <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/customers/customer/userProfile/invoice?invoice_id=${row.orderId}&customer_id=${row.customer_id}`}>
        //             {row.InvoiceNo}
        //         </Link>,
        //     sortable: true,
        //     wrap: true,
        //     center: false,
        // },
        {
            name: <H4>Txn Id</H4>,
            id: 'transaction_id',
            selector: row => row.txnId,
            sortable: true,
            wrap: true
        },
        {
            name: <H4>Address</H4>,
            id: 'billing_address',
            selector: row => row.Address,
            sortable: true,
            center: false,
            width: '130px',
            wrap: true
        },
        {
            name: <H4>Paid Date</H4>,
            id: 'paid_date',
            selector: row => row.PaidDate,
            sortable: true,
            center: false,
            width: '120px',
            wrap: true
        },
        {
            name: <H4>Amount Collected</H4>,
            id: 'collected_amount',
            selector: row => row.AmountCollected,
            sortable: true,
            center: false,
            wrap: true

        },
        {
            name: <H4>Collected By</H4>,
            id: 'collected_by',
            selector: row => row.CollectedBy,
            sortable: true,
            center: false,
            wrap: true
        },
    ];

    useEffect(() => {
        fetchCustomerPayment(1);
        userData();
    }, []);

    useEffect(() => {
        setValue('search', filters.searchKey);
    }, [setValue, filters.search]);


    useEffect(() => {
        if (filters.userId) {
            const selectedUser = apiUsers.find((user) => user.id === parseInt(filters.userId));
            if (selectedUser) {
                setValue('account', selectedUser.id.toString());
            }
        }
    }, [setValue, filters.userId, apiUsers]);

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const handleSort = (column) => {
        let newOrder = 'asc';
        if (sortedBy === column.id) {
            newOrder = sortedOrder === 'asc' ? 'desc' : 'asc';
            setSortConfig({ column: column.id, order: newOrder });
            navigate(`/report/payment-collection?search=${filters.searchKey}&start_date=${formatStartDate}&end_date=${formatEndDate}&user=${filters.userId}&sortBy=${column.id}&sortOrder=${newOrder}`);
        } else {
            newOrder = sortedOrder === 'asc' ? 'desc' : 'asc';
            setSortConfig({ column: column.id, order: newOrder });
            navigate(`/report/payment-collection?search=${filters.searchKey}&start_date=${formatStartDate}&end_date=${formatEndDate}&user=${filters.userId}&sortBy=${column.id}&sortOrder=${newOrder}`);
        }
    };

    const handleApiError = (status) => {
        if (status >= 400 && status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (status >= 500 && status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
    };

    const onSubmit = async (data) => {
        const searchKey = data.search || '';
        const start_date = startDate ? moment(startDate).format("DD-MM-YYYY") : '';
        const end_date = endDate ? moment(endDate).format("DD-MM-YYYY") : '';
        const userId = data.user || '';
        const queryParams = new URLSearchParams({
            search: searchKey,
            start_date,
            end_date,
            user: userId,
            sortBy: sortConfig.column || '',
            sortOrder: sortConfig.order || '',
        }).toString();
        navigate(`/report/payment-collection?${queryParams}`);
        setFilters({
            searchKey,
            start_date,
            end_date,
            userId
        });
        fetchCustomerPayment(currentPage, perPage);
    };

    const fetchCustomerPayment = async (page, size = perPage) => {
        setLoading(true);
        setCustomerList([]);
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1
            ? getCollectionReport + `?page=${page}&page_length=${size}&search=${filters.searchKey}
            &start_date=${formatStartDate}&end_date=${formatEndDate}&user_id=${filters.userId}&day=${param1}
            &sort_by=${sortConfig.column ? sortConfig.column : ''}&sort_order=${sortConfig.order ? sortConfig.order : ''}`
            : getCollectionReportRole + `?page=${page}&page_length=${size}&search=${filters.searchKey}
            &start_date=${formatStartDate}&end_date=${formatEndDate}&user_id=${filters.userId}
            &sort_by=${sortConfig.column ? sortConfig.column : ''}&sort_order=${sortConfig.order ? sortConfig.order : ''}`
        );
        if (response.status === true) {
            const valuePackages = response.data.payments.data;
            const SerialNo = (page - 1) * size + 1;
            const newCustomerList = Object.keys(valuePackages).map((e, index) => {
                return {
                    Si: SerialNo + index,
                    Name: valuePackages[e].customer_name,
                    Sub: valuePackages[e].effected_bins,
                    SubId: valuePackages[e].subscriber_id,
                    InvoiceNo: valuePackages[e].invoice_no,
                    Area: valuePackages[e].area_name,
                    Address: valuePackages[e].billing_address,
                    PaidDate: valuePackages[e].paid_date,
                    AmountCollected: authState.currency + valuePackages[e].collected_amount,
                    CollectedBy: valuePackages[e].created_name,
                    orderId: valuePackages[e].order_id,
                    customer_id: valuePackages[e].customer_id,
                    Type: valuePackages[e].invoice_type,
                    txnId: valuePackages[e].transaction_id,
                    payment_id: valuePackages[e].id
                };
            });
            settotalsum(response.data.total_amount);
            setCustomerList(newCustomerList);
            setTotalRows(response.data.payments.total);
        } else {
            handleApiError(data.status);
        }
        setLoading(false);
    };

    const exportCollectionExcel = async () => {
        setLoading(true);
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getCollectionReport +
            `?export=payment_report&search=${filters?.searchKey ?? ''}&start_date=${formatStartDate ?? ''}&end_date=${formatEndDate ?? ''}&account_id=${filters?.account_Filter ?? ''}&user_id=${filters?.userId ?? ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}` :
            getCollectionReportRole + `?export=payment_report&search=${filters?.searchKey ?? ''}&start_date=${formatStartDate ?? ''}&end_date=${formatEndDate ?? ''}&account_id=${filters?.account_Filter ?? ''}&bin=${filters.binId ?? ''}&user_id=${filters?.userId ?? ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}`);
        const dataToExport = response.data.payments.map(({ customer_name, bin_account, id,transaction_id, billing_address, paid_date, collected_amount, collected_by }, index) => ({ Sl: index + 1, Name: customer_name, Bin_Id: bin_account, Reciept: id, Txn_Id: transaction_id, Address: billing_address, Start_date: paid_date, Amount_collected: collected_amount, Collected_by: collected_by, }));
        if (response.status === true) {
            const ws = XLSX.utils.json_to_sheet(dataToExport);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'payment collection Data');
            XLSX.writeFile(wb, 'payment_colletion_report.xlsx');
        } else {
            handleApiError(data.status);
        }
        setLoading(false);
    };

    const exportCollectionPdf = async () => {
        setLoading(true);
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getCollectionReport +
            `?export=payment_report&search=${filters?.searchKey ?? ''}&start_date=${formatStartDate ?? ''}&end_date=${formatEndDate ?? ''}&account_id=${filters?.account_Filter ?? ''}&user_id=${filters?.userId ?? ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}` :
            getCollectionReportRole + `?export=payment_report&search=${filters?.searchKey ?? ''}&start_date=${formatStartDate ?? ''}&end_date=${formatEndDate ?? ''}&account_id=${filters?.account_Filter ?? ''}&bin=${filters?.binId ?? ''}&user_id=${filters?.userId ?? ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}`);
        const dataToExport = response.data.payments.map(({ customer_name, bin_account, id, transaction_id, billing_address, paid_date, collected_amount, collected_by }, index) => ({ Sl: index + 1, customer_name, bin_account, id, transaction_id, billing_address, paid_date, collected_amount, collected_by }));
        if (response.status === true) {
            const doc = new jsPDF();
            const columns = ["Sl", "Name", "Bin id", "Receipt", "Txn Id", "Address", "Start Date", "Amount Collected", "Collected by"];
            const rows = dataToExport.map(({ customer_name, bin_account, id, transaction_id, billing_address, paid_date, collected_amount, collected_by }, index) => [index + 1, customer_name, bin_account, id, transaction_id, billing_address, paid_date, collected_amount, collected_by]);
            doc.autoTable({
                head: [columns],
                body: rows,
                columnStyles: {
                    5: { cellWidth: 40 }
                },
                styles: { fontSize: 10 },
            });
            doc.save("collection_data.pdf");
        } else {
            handleApiError(data.status);
        }
        setLoading(false);
    };

    const handlePageChange = page => {
        fetchCustomerPayment(page);
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchCustomerPayment(page, newPerPage);
        setPerPage(newPerPage);
    };

    const userData = async () => {
        const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getUsers : getUsersRole);
        if (data.status === true) {
            setapiUsers(data.data);
        } else {
            handleApiError(data.status);
        }
    };

    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <Breadcrumbs mainTitle={PaymentCollectionRep} parent="Reports" title={PaymentCollectionRep} />
            <Progress details={StaticWidgetsData} />
            <Card className='cardWidth'>
                <CardHeader style={{ margin: '-25px 0 -25px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <H3>{PaymentCollectionList}</H3>
                    <div>
                        {(authState.userRole === 1 || authState.permissions.includes('export-report')) &&
                            <CardBody className="dropdown-basic">
                                <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                                    <DropdownToggle color="#fff" style={{ fontSize: '14px', zIndex: 1000 }} className="btn btn-primary mr-4">
                                        {Export} <i className="icofont icofont-arrow-up"></i>
                                    </DropdownToggle>
                                    <DropdownMenu container="body">
                                        <DropdownItem style={toggleStyle} onClick={() => exportCollectionExcel()} ><i className="fa fa-file-excel-o me-2"></i> Excel</DropdownItem>
                                        <DropdownItem style={toggleStyle} onClick={() => exportCollectionPdf()}><i className="fa fa-file-pdf-o me-2"></i> Pdf</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </CardBody>
                        }
                    </div>
                </CardHeader>

                <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                    <Row className="ps-3 gap-sm-3 gap-md-2 filterGap">
                        <Col sm="12" md='5' lg='2'>
                            <input className="form-control" placeholder={Search} type="text"
                                {...register('search')} />
                        </Col>
                        <Col sm="12" md="5" lg='2' className="form-element" >
                            <div style={{ position: 'relative', zIndex: 2 }}>
                                <DatePicker
                                    className="form-control digits w-100"
                                    selectsRange={true}
                                    startDate={startDate}
                                    endDate={endDate}
                                    onChange={(update) => {
                                        setDateRange(update);
                                    }}
                                    isClearable={true}
                                    monthsShown={2}
                                    popperPlacement="bottom"
                                    calendarClassName='parallel-calendar'
                                    placeholderText='Select Date Range'
                                />
                            </div>
                        </Col>
                        <Col sm="12" md="5" lg='2' className="form-element">
                            <UserDropdown
                                authState={authState}
                                registerName="user"
                                selectedUserId={filters.userId}
                                register={register}
                                setValue={setValue}
                            />
                        </Col>
                        <Col sm="12" md="5" lg='1' className="custom-filtrs">
                            <Btn attrBtn={{ color: "primary" }} type="submit">{Filter}</Btn>
                        </Col>
                    </Row>
                </Form>
                <CardBody>
                    <div className="order-history table-responsive">
                        <DataTable
                            columns={PaymentCollectionColumns}
                            data={customerLists}
                            onSort={handleSort} // Attach sorting handler here
                            sortServer // Enable server-side sorting
                            pagination
                            paginationServer
                            defaultSortAsc
                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                            paginationTotalRows={totalRows}
                            paginationDefaultPage={currentPage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                            fixedHeader
                        />
                    </div>
                </CardBody>
            </Card>
        </Fragment>
    );
};

export default CustomerPaymentReport;